const config = {
  version: `${process.env.CF_PAGES_COMMIT_SHA}${process.env.FR_BUILD_DATE}`,
  url: {
    api: 'https://api.smartagro.lv/app-v1',
    layers_cadastre: 'https://api.smartagro.lv/layers/cadastre',
    search_cadastre: 'https://api.smartagro.lv/search/cadastre',
    search_lad_block: 'https://karte.lad.gov.lv/arcgis/rest/services/karte_pub/MapServer/6/query',
    upload_file: 'https://api.smartagro.lv/upload/',
  },
  auth: {
    client_id: 'HtwdYiIYs2h2u92EFF6N8dCistkS3ISk',
    domain: 'smartagro.eu.auth0.com',
    redirect_uri: 'https://app.smartagro.lv'
  },
  basemap: {
    carto_key: 'cb1_3lzl_1_35c9e73f91feac4260fd4962',// https://carto.com/basemaps/apikey/
  },
  bookmarks: {
    default: {
      '00000': {
        bookm_id: '00000',
        bookm_name: 'Latvia',
        bookm_seq: 1,
        lat: 57.0,
        long: 24.7,
        zoom: 7
      }
    },
    seq_length: 5,
  },
  geoman: {
    measure_controls: {
      cutPolygon: false,
      dragMode: false,
      drawCircle: false,
      drawCircleMarker: false,
      drawMarker: false,
      drawPolygon: true,
      drawPolyline: true,
      drawRectangle: false,
      editMode: false,
      oneBlock: true,
      position: 'topright',
      removalMode: true,
    },
  },
  input: {
    bookmark: {
      name: {min_len: 1, max_len: 50},
    },
    plot: {
      name: {min_len: 1, max_len: 50},
    },
    profile: {
      comp_name: {min_len: 0, max_len: 50},
      full_name: {default: true, min_len: 1, max_len: 50},
      mon_freq: {values: ['disabled', 'quarter', 'month', 'week']},
      phone: {min_len: 0, max_len: 20},
    }
  },
  plots: {
    show_attrs: [
      'mon_status',
      'mon_result',
      'mon_date',
      'cad_nr',
      'cad_info',
      'reg_id',
      'reg_info',
      'ext_id',
      'ext_info',
      'area_ha',
    ],
    extra_attrs: [
      'apaksnog',
      'atslega',
      'kadnum',
      'kopkraja',
      'kvartals',
    ],
    main_attrs: [
      'area_ha',
      'cad_nr',
      'mon_date',
      'mon_result',
      'mon_status',
    ],
    complex_attrs: [
      'cad_info',
      'ext_info',
      'reg_info',
    ],
  },
  nav: {
    top: ['appname'],
    mid: ['bookmarks', 'plots', 'layers'],
    bottom: ['profile'],
  },
  panel_buttons: {
    bookmarks: ['add_bookmark'],
    profile: ['edit_profile', 'login_logout'],
    plots: ['add_plot', 'upload_file'],
    layers: ['empty'],
  },
  proj4: {
    lks92: '+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=-6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
  },
  search: {
    default_zoom: 17,
    plot_params: [
      'plot_name',
      'ext_id',
      'reg_id',
      'cad_nr',
    ],
    regex_address: /^[A-Za-z]{3,}/,
    regex_cadastre1: /^[0-9]{1}[0-9,\s]{9,}[0-9]{1}$/,
    regex_cadastre2: /^[0-9]{11,}$/,
    regex_coords1: /^[0-9]{2}[\.,\,]?[0-9]*[\s]+[0-9]{2}[\.,\,]?[0-9]*$/, //separated by space
    regex_coords2: /^[0-9]{2}[\.]?[0-9]*[\s]*[,][\s]*[0-9]{2}[\.]?[0-9]*$/, //separated by comma
    regex_coord: /^[0-9]{2}[\.]?[0-9]*$/,
    regex_lad_block: /^[0-9]{5}\-{1}[0-9]{5}$/,
  },
  timeout: {
    cad_info: 10000,
  },
  util: {
    cad_info_fields: [ //case sensitive
      'CODE',
      'GEOM_ACTUAL_DATE',
      'PARCEL_TYPE',
    ],
  },
};
export default config;
